import homeIcon from './constant/home.svg';
import dashboard from './constant/dashboard.svg';
import adminManage from './constant/admin-manage.svg';
import member from './constant/member.svg';
import pos from './constant/pos.svg';
import branchManagement from './constant/branch-management.svg';
import contactManagement from './constant/contact-management.svg';
import advertisement from './constant/advertisement.svg';
import shopMangement from './constant/shop-management.svg';
import bookingManagement from './constant/booking-management.svg';
import bookingManagement2 from './constant/booking-management2.svg';
import packages from './constant/packages.svg';
import promotions from './constant/promotions.svg';
import coupons from './constant/coupons.svg';
import salesperson from './constant/salesperson.svg';
import qrcodePoint from './constant/qrcode-point.svg';
import customerAddpoint from './constant/customer-addpoint.svg';
import customerAddwallet from './constant/customer-addwallet.svg';
import addPoint from './constant/add-point.svg';
import addWallet from './constant/add-wallet.svg';
import uploadFile from './constant/upload-file.svg';
import redeemHistory from './constant/redeem-history.svg';
import report from './constant/report.svg';
import allnotification from './constant/allnotification.svg';
import setting from './constant/setting.svg';
import miniPOS from './constant/mini-pos.svg';
import { PERMISSIONS } from '@/app/data/permissions';
import LaunchIcon from '@mui/icons-material/Launch';
import aiMenuIcon from './constant/ai-menu.svg';
import { MenuKeys } from '@/app/pages/home/constants/menuKeys';
import { isCustomerFeatureEnabled } from '@/app/data/customerFeatures';

export const menuItems = seqId => [
  { id: 'menu.home', route: `/shop/${seqId}/home`, icon: homeIcon },
  {
    id: 'menu.ai',
    route: `/shop/${seqId}/admin/ai`,
    icon: aiMenuIcon,
    permission: PERMISSIONS.AI_MANAGEMENT,
    enabled: ctx => ctx.shop?.enableAI
  },
  {
    id: 'menu.dashboard.new',
    route: '',
    icon: dashboard,
    submenu: [
      {
        id: 'menu.dashboard.branch',
        route: `/shop/${seqId}/admin/statistics/branches`,
        permission: PERMISSIONS.DASHBOARD_BRANCH,
        enabled: ctx => ctx.shop?.maxNumberOfBranches > 0
      },
      {
        id: 'menu.dashboard.main',
        route: `/shop/${seqId}/admin/statistics/main`,
        permission: PERMISSIONS.DASHBOARD_OVERALL
      },
      // No ?branch= so the active highlight matches; GroupStatPage defaults to the logged-in branch.
      {
        id: 'menu.dashboard.group',
        route: `/shop/${seqId}/admin/statistics/groups`,
        permission: PERMISSIONS.DASHBOARD_GROUP
      },
      {
        id: 'menu.dashboard.point',
        route: `/shop/${seqId}/admin/statistics/point`,
        permission: PERMISSIONS.DASHBOARD_POINT
      },
      {
        id: 'menu.dashboard.coupon',
        route: `/shop/${seqId}/admin/statistics/coupon`,
        permission: PERMISSIONS.DASHBOARD_COUPON,
        enabled: ctx => ctx.shop?.enableCoupon
      },
      {
        id: 'menu.dashboard.package',
        route: `/shop/${seqId}/admin/statistics/package`,
        permission: PERMISSIONS.DASHBOARD_PACKAGE,
        enabled: ctx => ctx.shop?.enablePackage
      },
      {
        id: 'menu.dashboard.promotion',
        route: `/shop/${seqId}/admin/statistics/promotion`,
        permission: PERMISSIONS.DASHBOARD_PROMOTION,
        enabled: ctx => ctx.shop?.enablePromotion
      },
      {
        id: 'menu.dashboard.wallet',
        route: `/shop/${seqId}/admin/statistics/wallet`,
        permission: PERMISSIONS.DASHBOARD_WALLET,
        enabled: ctx => ctx.shop?.enableWallet
      },
      {
        id: 'menu.dashboard.sales',
        route: `/shop/${seqId}/admin/statistics/sales`,
        permission: PERMISSIONS.DASHBOARD_SALES
      }
    ]
  },
  {
    id: 'MENU_ADMIN_MANAGE',
    icon: adminManage,
    submenu: [
      {
        id: 'MENU_ROLE_MANAGE',
        route: `/shop/${seqId}/admin/rolesManage`,
        isSubMenu: true,
        permission: PERMISSIONS.MEMBER_MANAGE_ADMIN
      }
    ]
  },
  {
    id: 'MENU_MEMBER',
    route: '',
    icon: member,
    submenu: [
      {
        id: 'MENU_INVITE_FRIEND',
        route: `/shop/${seqId}/invite`,
        permission: PERMISSIONS.MEMBER_INVITE
      },
      {
        id: 'MENU_MANAGE_MEMBER_GROUP',
        route: `/shop/${seqId}/admin/edit-groups`,
        permission: PERMISSIONS.MEMBER_VIEW_GROUPS
      },
      {
        id: 'MENU_USER_MANAGE',
        route: `/shop/${seqId}/admin/customers`,
        permission: PERMISSIONS.MEMBER_VIEW
      },
      {
        id: 'MENU_MEMBER_GET_MEMBER_MANAGEMENT',
        route: `/shop/${seqId}/admin/mgm`,
        permission: PERMISSIONS.MGM_MANAGEMENT,
        enabled: enableMgmCb
      },
      {
        id: 'MENU_MEMBER_GET_MEMBER_HISTORY',
        route: `/shop/${seqId}/admin/mgm/history`,
        permission: PERMISSIONS.MGM_VIEW_HISTORY,
        enabled: enableMgmCb
      },
      {
        id: 'MENU_MEMBER_GET_MEMBER_REPORT',
        route: `/shop/${seqId}/admin/mgm/report`,
        permission: PERMISSIONS.MGM_VIEW_REPORT,
        enabled: enableMgmCb
      },
      {
        id: 'MENU_FUNSHARING',
        route: `/shop/${seqId}/admin/funsharing`,
        enabled: ({ shop }, can) =>
          shop?.enableFunsharing &&
          (can(PERMISSIONS.FUNSHARING_VIEW_LIST) ||
            can(PERMISSIONS.FUNSHARING_VIEW_HISTORY) ||
            can(PERMISSIONS.FUNSHARING_VIEW_REPORT))
      }
    ]
  },
  {
    id: 'menu.pos',
    route: `/shop/${seqId}/admin/pos`,
    icon: pos,
    enabled: ctx => ctx.shop?.enableSmartPos,
    permission: PERMISSIONS.SMART_POS_FULL_ACCESS
  },
  {
    id: 'MENU_BRANCH_MANAGEMENT',
    route: `/shop/${seqId}/admin/branch-management`,
    icon: branchManagement,
    permissions: [
      PERMISSIONS.BRANCH_VIEW,
      PERMISSIONS.BRANCH_EDIT,
      PERMISSIONS.BRANCH_MANAGEMENT,
      PERMISSIONS.BRANCH_INVITE
    ],
    enabled: ctx => ctx.shop?.maxNumberOfBranches > 0
  },
  {
    id: 'contact.management',
    route: `/shop/${seqId}/admin/contact-management`,
    icon: contactManagement,
    enabled: ctx => ctx.shop?.contactEnabled,
    submenu: [
      {
        id: 'board.template.setting',
        route: `/shop/${seqId}/admin/board/template`,
        permission: PERMISSIONS.CONTACT_TEMPLATE_MANAGEMENT
      },
      {
        id: 'contact.management',
        route: `/shop/${seqId}/admin/customer-contact`,
        permission: PERMISSIONS.CONTACT_VIEW
      }
    ]
  },
  {
    id: 'menu.advertisement',
    route: '',
    icon: advertisement,
    submenu: [
      {
        id: 'menu.advertisement.manage',
        route: `/shop/${seqId}/admin/advertisement`,
        permission: PERMISSIONS.ADVERTISEMENT_VIEW_LIST
      },
      {
        id: 'menu.broadcast.manage',
        route: `/shop/${seqId}/admin/broadcast`,
        permission: PERMISSIONS.BROADCAST_VIEW,
        enabled: ctx => ctx.shop?.enableWhatsapp || ctx.shop?.enableLineNotification
      },
      {
        id: 'menu.recurringBroadcast.manage',
        route: `/shop/${seqId}/admin/recurring-broadcast`,
        permission: PERMISSIONS.BROADCAST_RECURRING_VIEW,
        enabled: ctx => ctx.shop?.enableRecurringBroadcast
      }
    ]
  },
  {
    id: 'menu.shop.management',
    route: '',
    icon: shopMangement,
    enabled: ctx => ctx.shop?.enableShoppingCart,
    submenu: [
      {
        id: 'menu.category',
        route: `/shop/${seqId}/admin/category`,
        permission: PERMISSIONS.SHOP_PRODUCT_VIEW_CATEGORY
      },
      {
        id: 'menu.product.list',
        route: `/shop/${seqId}/admin/products`,
        permission: PERMISSIONS.SHOP_PRODUCT_VIEW_LIST
      },
      {
        id: 'menu.addOn.group.management',
        route: `/shop/${seqId}/admin/add-on-group/management`,
        permission: PERMISSIONS.SHOP_PRODUCT_ADD_ON_GROUP_VIEW
      },
      {
        id: 'menu.addOn.management',
        route: `/shop/${seqId}/admin/add-on/management`,
        permission: PERMISSIONS.SHOP_PRODUCT_ADD_ON_VIEW
      },
      {
        id: 'menu.inventory',
        route: `/shop/${seqId}/admin/products/inventory`,
        permission: PERMISSIONS.SHOP_PRODUCT_VIEW_STOCK
      },
      {
        id: 'menu.inventory.request.management',
        route: `/shop/${seqId}/admin/inventory-request-management`,
        enabled: ctx => ctx.shop?.enableGas
      },
      {
        id: 'menu.order.gas.create',
        route: `/shop/${seqId}/order-gas/create`,
        enabled: ctx => ctx.shop?.enableGas
      },
      {
        id: 'menu.inventory.history',
        route: `/shop/${seqId}/admin/inventory-history`,
        permission: ctx => ctx.shop?.enableGas
      },
      {
        id: 'menu.payment.management',
        route: `/shop/${seqId}/admin/paymentManagement`,
        permissions: [PERMISSIONS.SHOPPING_PAYMENT_SETTING_VIEW, PERMISSIONS.SHOPPING_PAYMENT_SETTING_EDIT]
      },
      {
        id: 'menu.shipment.management',
        route: `/shop/${seqId}/admin/shipment`,
        permission: PERMISSIONS.SHOPPING_SHIPPING_MANAGEMENT_VIEW
      },
      {
        id: 'menu.shopping.cart.setting',
        route: `/shop/${seqId}/admin/shopping-cart-setting`,
        permission: PERMISSIONS.SHOPPING_CART_SETTING_VIEW
      },
      {
        id: 'menu.admin.order.history',
        route: `/shop/${seqId}/admin/orderManagement`,
        permission: PERMISSIONS.SHOPPING_ORDER_VIEW,
        getAlertNumber: ctx => ctx.waitConfirmOrderAmount
      }
    ]
  },
  {
    id: 'menu.mini.pos',
    route: `/shop/${seqId}/mini-pos/home`,
    icon: miniPOS,
    openNewTab: true,
    enabled: ctx => ctx.shop?.enableMiniPos,
    endAdornment: ctx => <LaunchIcon sx={{ color: ctx.style.icColor }} />,
    permission: PERMISSIONS.MINIPOS_ACCESS
  },
  {
    id: 'menu.booking.management',
    route: 'booking-management',
    icon: bookingManagement,
    getAlertNumber: ctx => (ctx.user?.type !== 'customer' ? ctx.waitConfirmBookingAmount : 0),
    enabled: ctx => ctx.shop?.isBooking,
    submenu: [
      {
        id: 'menu.booking.management',
        route: `/shop/${seqId}/booking-management`,
        permission: PERMISSIONS.BOOKING_VIEW_LIST,
        getAlertNumber: ctx => ctx.waitConfirmBookingAmount
      },
      {
        id: 'menu.booking.setting',
        route: `/shop/${seqId}/booking-management/setting`,
        permission: PERMISSIONS.BOOKING_SETTING
      },
      {
        id: 'menu.invite.customer.booking',
        route: `/shop/${seqId}/booking-management/invite`,
        permission: PERMISSIONS.BOOKING_INVITE
      }
    ]
  },
  {
    id: 'menu.booking2.management',
    route: 'booking2-management',
    icon: bookingManagement2,
    getAlertNumber: ctx => (ctx.user?.type !== 'customer' ? ctx.totalWaitingBooking2Count : 0),
    enabled: ctx => ctx.shop?.isBooking2,
    submenu: [
      {
        id: 'menu.booking2.management',
        route: `/shop/${seqId}/booking2-management`,
        permission: PERMISSIONS.BOOKING2_VIEW_LIST,
        getAlertNumber: ctx => ctx.totalWaitingBooking2Count
      },
      {
        id: 'menu.booking2.setting',
        route: `/shop/${seqId}/booking2-setting`,
        permission: PERMISSIONS.BOOKING2_SETTING
      },
      {
        id: 'menu.invite2.customer.booking',
        route: `/shop/${seqId}/booking2-invite`,
        permission: PERMISSIONS.BOOKING2_INVITE
      }
    ]
  },
  {
    id: 'SHOP.PACKAGE.CREATE',
    route: `/shop/${seqId}/admin/packages`,
    icon: packages,
    permission: PERMISSIONS.PACKAGE_VIEW
  },
  {
    id: 'MENU_CREATE_PROMOTION',
    route: `/shop/${seqId}/admin/promotions`,
    icon: promotions,
    permission: PERMISSIONS.PROMOTION_VIEW
  },
  {
    id: 'MENU_AUTO_PROMOTION',
    route: `/shop/${seqId}/admin/auto-promotions`,
    icon: promotions,
    permission: PERMISSIONS.AUTO_PROMOTION_VIEW
  },
  {
    id: 'MENU_CREATE_COUPONS',
    route: `/shop/${seqId}/admin/coupons`,
    icon: coupons,
    permission: PERMISSIONS.COUPON_VIEW
  },
  {
    id: 'menu.sales.management',
    route: `/shop/${seqId}/admin/salesperson`,
    icon: salesperson,
    enabled: ctx => ctx.shop?.enableSalesQr,
    permission: PERMISSIONS.RECOMMENDER_QR_VIEW
  },
  {
    id: 'MENU_CREATE_POINT_QRCODE',
    route: `/shop/${seqId}/admin/qrcode`,
    icon: qrcodePoint,
    permission: PERMISSIONS.POINT_ADD_BY_PERMANENT_QR
  },
  {
    id: 'menu.add.point.by.customer',
    route: `/shop/${seqId}/admin/customer-addpoint`,
    icon: customerAddpoint,
    permission: PERMISSIONS.POINT_ADD_BY_QR
  },
  {
    id: 'menu.add.point',
    route: `/shop/${seqId}/admin/addPoint`,
    icon: addPoint,
    permission: PERMISSIONS.POINT_ADD_BY_PHONE
  },
  {
    id: 'menu.add.wallet.by.customer',
    route: `/shop/${seqId}/admin/customer-addwallet`,
    icon: customerAddwallet,
    permission: PERMISSIONS.WALLET_ADD_BY_QR
  },
  {
    id: 'menu.addWallet',
    route: `/shop/${seqId}/admin/add-wallet`,
    icon: addWallet,
    permission: PERMISSIONS.WALLET_ADD_BY_PHONE
  },
  {
    id: 'menu.upload.file',
    route: `/shop/${seqId}/admin/upload-file`,
    icon: uploadFile,
    permission: PERMISSIONS.UPLOAD_ACCESS,
    enabled: ctx => ctx.shop?.enableUploadFile
  },
  {
    id: 'MENU_REDEEM_HISTORY',
    route: `/shop/${seqId}/redeem-history`,
    icon: redeemHistory,
    enabled: (ctx, can) => {
      return can(PERMISSIONS.POINT_HISTORY) || can(PERMISSIONS.WALLET_HISTORY);
    }
  },
  { id: 'MENU_REPORT', route: `/shop/${seqId}/admin/report`, icon: report, permission: PERMISSIONS.REPORT_ACCESS },
  {
    id: 'menu.notification',
    route: `/shop/${seqId}/admin/notification/allnotification`,
    icon: allnotification,
    permission: PERMISSIONS.NOTIFICATION_VIEW
  },
  {
    id: 'MENU_SETTING',
    route: 'shop-management',
    icon: setting,
    submenu: [
      {
        id: 'MENU_SHOP_SETTING',
        route: `/shop/${seqId}/admin/shop-setting`,
        permission: PERMISSIONS.SETTING_SHOP_VIEW
      },
      {
        id: 'menu.registration.setting',
        route: `/shop/${seqId}/admin/registration-perks`,
        permission: PERMISSIONS.SETTING_NEW_USER_VIEW
      },
      {
        id: 'menu.conversion.rate',
        route: `/shop/${seqId}/admin/conversion-rate`,
        permissions: [PERMISSIONS.SETTING_CONVERSION_RATE_VIEW, PERMISSIONS.SETTING_CONVERSION_RATE_EDIT]
      },
      {
        id: 'menu.theme.setting',
        route: `/shop/${seqId}/admin/setting`,
        permission: PERMISSIONS.SETTING_THEME_VIEW
      },
      {
        id: 'menu.shortcut.setting',
        route: `/shop/${seqId}/admin/setting-shortcut`,
        permission: PERMISSIONS.SETTING_SHORTCUT_VIEW,
        ctx: ctx => ctx.shop?.isShortcut
      },
      {
        id: 'menu.notification.setting',
        route: `/shop/${seqId}/admin/notification/setting`,
        permission: PERMISSIONS.SETTING_NOTIFICATION_VIEW
      },
      {
        id: 'menu.lineOA.setting',
        route: `/shop/${seqId}/admin/setting-line-oa`,
        permission: PERMISSIONS.SETTING_LINE_VIEW,
        enabled: ctx => ctx.shop?.enableLineNotification
      },
      {
        id: 'MENU_FILTER_MANAGEMENT',
        route: `/shop/${seqId}/admin/filter`,
        permission: PERMISSIONS.SETTING_CONDITION_VIEW,
        enabled: ctx => ctx.shop?.enableWhatsapp || ctx.shop?.enableLineNotification
      },
      {
        id: 'MENU.CONTACT_US',
        route: `/shop/${seqId}/contact`,
        permission: PERMISSIONS.SETTING_CONTACT_VIEW
      }
    ]
  }
];

export const customerMenuItems = seqId => [
  { id: 'menu.home', route: `/shop/${seqId}/home` },
  {
    id: 'MENU.SHOW_DEPOSIT',
    route: `/shop/${seqId}/products`,
    settingKey: 'menu.deposit',
    enabled: ctx => isCustomerFeatureEnabled(ctx.shop, MenuKeys.DEPOSIT)
  },
  {
    id: 'menu.booking',
    route: `/shop/${seqId}/booking-management/new`,
    settingKey: 'menu.booking.new',
    enabled: ctx =>
      ctx.shop?.isBooking && ctx.bookingSetting?.isActive && isCustomerFeatureEnabled(ctx.shop, MenuKeys.BOOKING)
  },
  {
    id: 'menu.booking2',
    route: `/shop/${seqId}/booking2-createbooking`,
    settingKey: 'menu.booking2',
    enabled: ctx =>
      ctx.shop?.isBooking2 &&
      ctx.booking2ShopSetting?.isActiveCustomerBooking2Menu &&
      isCustomerFeatureEnabled(ctx.shop, MenuKeys.BOOKING2)
  },
  {
    id: 'menu.history',
    route: '',
    submenu: [
      {
        id: 'menu.booking.history',
        route: `/shop/${seqId}/booking-management`,
        enabled: ctx => ctx.shop?.isBooking && isCustomerFeatureEnabled(ctx.shop, MenuKeys.BOOKING)
      },
      {
        id: 'menu.booking2.history',
        route: `/shop/${seqId}/booking2-history/branch-all`,
        enabled: ctx => ctx.shop?.isBooking2 && isCustomerFeatureEnabled(ctx.shop, MenuKeys.BOOKING2)
      },
      {
        id: 'menu.order.history.new',
        route: `/shop/${seqId}/order-history`,
        settingKey: 'menu.order.history',
        enabled: ctx => ctx.shop?.enableShoppingCart && isCustomerFeatureEnabled(ctx.shop, MenuKeys.ORDER_HISTORY)
      },
      {
        id: 'menu.order.history.gas',
        route: `/shop/${seqId}/gas-order-history`,
        settingKey: 'menu.order.history',
        enabled: ctx =>
          ctx.shop?.enableShoppingCart &&
          ctx.shop?.enableGas &&
          isCustomerFeatureEnabled(ctx.shop, MenuKeys.ORDER_HISTORY)
      },
      {
        id: 'menu.history',
        route: `/shop/${seqId}/history`,
        enabled: ctx => isCustomerFeatureEnabled(ctx.shop, MenuKeys.CUSTOMER_HISTORY)
      }
    ]
  },
  {
    id: 'MENU.CONTACT_US',
    route: `/shop/${seqId}/contact`,
    settingKey: 'menu.contact.us',
    enabled: ctx => isCustomerFeatureEnabled(ctx.shop, MenuKeys.CONTACT_US)
  },
  { id: 'menu.term', route: `/shop/${seqId}/term`, enabled: ctx => ctx.isTerm }
];

function enableMgmCb({ shop, isGlobalAdmin }) {
  return shop?.enableLineNotification && shop?.enableMGM && isGlobalAdmin;
}
